import React from 'react';

const SUPPORTED_FLAGS =
  '["af","ax","al","dz","as","ad","ao","ai","aq","ag","ar","am","aw","ac","au","at","az","bs","bh","bd","bb","es-pv","by","be","bz","bj","bm","bt","bo","bq","ba","bw","bv","br","io","bn","bg","bf","bi","cv","kh","cm","ca","ic","es-ct","ky","cf","cefta","td","cl","cn","cx","cp","cc","co","km","ck","cr","hr","cu","cw","cy","cz","ci","cd","dk","dg","dj","dm","do","eac","ec","eg","sv","gb-eng","gq","er","ee","sz","et","eu","fk","fo","fm","fj","fi","fr","gf","pf","tf","ga","es-ga","gm","ge","de","gh","gi","gr","gl","gd","gp","gu","gt","gg","gn","gw","gy","ht","hm","va","hn","hk","hu","is","in","id","ir","iq","ie","im","il","it","jm","jp","je","jo","kz","ke","ki","xk","kw","kg","la","lv","arab","lb","ls","lr","ly","li","lt","lu","mo","mg","mw","my","mv","ml","mt","mh","mq","mr","mu","yt","mx","md","mc","mn","me","ms","ma","mz","mm","na","nr","np","nl","nc","nz","ni","ne","ng","nu","nf","kp","mk","gb-nir","mp","no","om","pk","pw","pa","pg","py","pe","ph","pn","pl","pt","pr","qa","cg","ro","ru","rw","re","bl","sh","kn","lc","mf","pm","vc","ws","sm","st","sa","gb-sct","sn","rs","sc","sl","sg","sx","sk","si","sb","so","za","gs","kr","ss","es","lk","ps","sd","sr","sj","se","ch","sy","tw","tj","tz","th","tl","tg","tk","to","tt","ta","tn","tm","tc","tv","tr","ug","ua","ae","gb","un","um","us","xx","uy","uz","vu","ve","vn","vg","vi","gb-wls","wf","eh","ye","zm","zw"]';

const SUPPORTED_COUNTRY_FLAGS = JSON.parse(SUPPORTED_FLAGS);

function ImageFlags(props) {
  const {countryCode, round = false, ...rest} = props;

  const flagCode = countryCode ? countryCode.toLowerCase() : '';
  const isSupported = SUPPORTED_COUNTRY_FLAGS.includes(flagCode);

  if (!isSupported || !flagCode) {
    return null;
  }

  return (
    <div {...rest}>
      <span className={`fi fi-${flagCode}  ${round ? 'fis' : ''}`} />
    </div>
  );
}

export default ImageFlags;
